const isValidDate = (date) => {
  try {
    if (!date)
      return false;
    const d = new Date(date);
    return !!d && !Number.isNaN(d.getTime());
  } catch (error) {
    return false;
  }
};
export {
  isValidDate
};
//# sourceMappingURL=date.js.map
